export default {
  LOAD_BOARD(state, data) {
    state.boardData = data;
  },

  LOAD_BOARD_LIST(state, data) {
    state.list = data;
  },

  LOAD_BOARD_TYPE_LIST(state, data) {
    state.types = data;
  },

  LOAD_POST(state, data) {
    state.postInfo = data;
  },

  LOAD_POST_IDS(state, data) {
    state.postIds = data;
  },

  LOAD_POST_LIST(state, data) {
    state.postListInfo = data;
    state.list = data.data;
  },

  LOAD_RISK_ASSESSMENT(state, data) {
    state.riskAssessment = data;
  },

  LOAD_COMMENT_LIST(state, data) {
    state.commentList = data;
  },

  UPDATE_COMMENT(state) {
    state.deleteSuccess = true;
  },

  DELETE_COMMENT(state) {
    state.deleteSuccess = true;
  },

  LOAD_PHOTO_LIST(state, data) {
    state.photoList = data;
  },

  DELETE_PHOTO(state, data) {},

  DELETE_PHOTO_LIST(state, data) {},

  LOAD_FILE_LIST(state, data) {
    state.fileList = data;
  },

  UPLOAD_FILE_LIST(state, data) {
    state.uploadFileList = data;
  },

  DOWNLOAD_FILE(state, data) {
    state.downloadFile = data;
  },

  SET_BOARD_CONNECT_823(state, postID) {
    state.boardConnect823 = postID;
  },

  // 게시글 숨김 기능 관련 mutations
  LOAD_HIDDEN_POST_LIST(state, data) {
    state.hiddenPostList = data.data;
    state.hiddenPostListInfo = data;
  },

  CHECK_SAFETY_MANAGER(state, data) {
    // 안전관리자 여부를 확인하여 상태를 업데이트
    state.isSafetyManager = data.isSafetyManager;
  },

  HIDE_POST(state, data) {
    // 게시글 숨김 처리 성공 시 기존 목록에서 해당 게시글을 숨김 상태로 업데이트
    if (state.list && Array.isArray(state.list)) {
      const postIndex = state.list.findIndex(post => post.post_id === data.post_id);
      if (postIndex !== -1) {
        state.list[postIndex].is_hidden = true;
        state.list[postIndex].hidden_at = data.hidden_at;
      }
    }
  },

  UNHIDE_POST(state, data) {
    // 게시글 숨김 해제 성공 시 기존 목록에서 해당 게시글을 숨김 해제 상태로 업데이트
    if (state.list && Array.isArray(state.list)) {
      const postIndex = state.list.findIndex(post => post.post_id === data.post_id);
      if (postIndex !== -1) {
        state.list[postIndex].is_hidden = false;
        state.list[postIndex].hidden_at = null;
      }
    }
    // 숨겨진 게시글 목록에서 제거
    if (state.hiddenPostList && Array.isArray(state.hiddenPostList)) {
      state.hiddenPostList = state.hiddenPostList.filter(post => post.post_id !== data.post_id);
    }
  },

  LOAD_POST_HIDDEN_STATUS(state, data) {
    state.postHiddenStatus = data;
  },

  BULK_HIDE_POSTS(state, data) {
    state.bulkHideResult = data;
    // 일괄 숨김 처리된 게시글들을 기존 목록에서 업데이트
    if (state.list && Array.isArray(state.list) && data.hidden_post_ids) {
      data.hidden_post_ids.forEach(postId => {
        const postIndex = state.list.findIndex(post => post.post_id === postId);
        if (postIndex !== -1) {
          state.list[postIndex].is_hidden = true;
          state.list[postIndex].hidden_at = new Date().toISOString();
        }
      });
    }
  },

  BULK_UNHIDE_POSTS(state, data) {
    state.bulkUnhideResult = data;
    // 일괄 숨김 해제된 게시글들을 숨겨진 게시글 목록에서 제거
    if (state.hiddenPostList && Array.isArray(state.hiddenPostList) && data.unhidden_post_ids) {
      state.hiddenPostList = state.hiddenPostList.filter(
        post => !data.unhidden_post_ids.includes(post.post_id)
      );
    }
  },

  LOAD_POST_HAS_VALUE(state, data) {
    // has-value API 조회 결과 저장
    state.postHasValueList = data;
  },
};
